import React from "react";
import AuthContainer from "../layouts/AuthContainer";
import Login from "../views/Auth/Login";
import { createRoute } from "./helpers";

const authRoutes = {
  element: <AuthContainer />,
  children: [
    {
      path: "/login",
      element: <Login />,
    },
    createRoute("/forgot-password", "Auth/ForgotPassword"),
    createRoute("/reset-password", "Auth/ResetPassword"),
    createRoute("/cancel-deletion", "Auth/CancelAccountDeletion"),
    createRoute("/verify-email", "Auth/VerifyEmail"),
    createRoute("/email-verification-sent", "Auth/EmailVerificationSent"),

    // Registration flow
    createRoute("/register/spouse", "Auth/RegisterSpouse"),
    createRoute("/register/location/email", "Auth/RegisterWaitingEmail"),
    createRoute("/register/location", "Auth/RegisterLocation"),
    createRoute("/register/children", "Auth/RegisterChildren"),
    createRoute("/register/other-children", "Auth/RegisterOtherChildren"),
    createRoute("/register/lawyer", "Auth/RegisterLawyer"),
    createRoute("/register/email", "Auth/RegisterEmail"),
    createRoute("/register/password", "Auth/RegisterPassword"),
    createRoute("/register/complete", "Auth/RegisterComplete"),
  ],
};

export default authRoutes;
